<template>
  <div class="review-box">
    <div>
      <div class="header">
        <div class="header-inner">
          <p>
            <span class="label">上报机构：</span>
            <span class="content">{{ reportingAgency | strFilter2 }}</span>
          </p>
          <p>
            <span class="label">上报原因：</span>
            <span class="content">{{ reasonReporting | getReason }}</span>
          </p>
        </div>
      </div>
      <div class="form">
        <div class="review-result">
          <div class="label">审核结果</div>
          <div class="content">
            <van-radio-group v-model="resultRadio" direction="horizontal">
              <van-radio name="1">
                通过
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
              <van-radio name="2">
                不通过
                <template #icon="props">
                  <img class="img-icon" :src="props.checked ? activeIcon : inactiveIcon" />
                </template>
              </van-radio>
            </van-radio-group>
          </div>
        </div>
        <!-- 审核意见 -->
        <div class="Audit-opinion">
          <p class="title">审核意见
            <span style="font-family: PingFangSC-Regular;font-weight: 400;font-size: 14px;color: #F94F4E;">*</span>
          </p>
          <van-field
              class="textarea"
              v-model="content"
              autosize
              type="textarea"
              maxlength="500"
              placeholder="请输入"
            />
          <!-- <textarea
            v-model="content"
            class="textarea"
            placeholder="请输入"
            cols="30"
            rows="10"
            maxlength="500"
          ></textarea> -->
          <div class="tip">{{ content.length }}/500</div>
        </div>
      </div>

    </div>
    <div class="btn-box">
      <div class="btn" :class="{'disable': !content}" @click="confirm">确定</div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.review-box {
  padding-bottom: 34px;
  min-height: 100vh;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  .header {
    background-color: white;
    margin: 20px 16px 0;
      .header-inner {
        background-repeat: no-repeat;
        background-image: url('../../../../assets/refund/pic_bgMessage@2x.png');
        padding: 16px;
        background-size: 100%;
        background-position: bottom;
        background-color: #f1fbf6;
        p {
          line-height: 25px;
          .label {
            font-weight: 400;
            font-size: 14px;
            color: #71747A;
          }
          .content {
            font-weight: 400;
            font-size: 14px;
            color: #1E2226;
          }
        }
    }
  }
  .form {
    padding: 0 16px;
    .review-result {
      padding: 27px 0 20px;
      border-bottom: 1px solid #eeeeee;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .address-inp-icon {
        width: 16px;
        height: 16px;
        position: relative;
        right: 28px;
      }
      .address-inp {
        background-color: white;
        width: 100%;
        height: 44px;
        padding-right: 28px;
        padding-left: 15px;
      }
      .label {
        font-size: 14px;
        color: #666666;
        span {
          color: red;
          vertical-align: middle;
          margin-left: 2px;
        }
      }
      /deep/.content {
        .van-field__control {
          text-align: right;
        }
        .van-radio__label {
          font-size: 14px;
          color: #171a1d;
        }
        .van-radio__icon {
          display: flex;
          align-items: center;
          width: 18px;
          height: 18px;
        }
        span {
          font-size: 14px;
          color: #171a1d;
        }
        .arrow {
          font-size: 16px;
          vertical-align: sub;
          margin-left: 5px;
        }
      }
    }
    .Audit-opinion {
      position: relative;
      .title {
        font-size: 14px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 20px;
      }
      /deep/.textarea {
        width: 100%;
        background: #f8f9fb;
        padding: 16px 4px 16px 16px;
        border-radius: 4px 4px 0 0;
        border: 0;
        font-size: 14px;
        line-height: 20px;
        box-sizing: border-box;
        .van-field__control {
          min-height: 120px;
          max-height: 320px;
        }
          .van-field__control::-webkit-scrollbar {
              width: 3px;
          }
          .van-field__control::-webkit-scrollbar-thumb {
              background: #E4E5E8;
          }
          .van-field__control::-webkit-scrollbar-track {
              background: #F8F9FB;
          }
      }
      .tip {
        text-align: right;
        padding-right: 16px;
        background: #f8f9fb;
        width: 100%;
        position: relative;
        top: -15px;
        font-size: 14px;
        color: #cccccc;
        border-radius: 0 0 4px 4px;
        line-height: 25px;
      }
    }
  }
  .btn-box {
    padding: 0 16px;
    width: 100%;
    .btn {
      background-color: #37b375;
      padding: 16px 0;
      text-align: center;
      font-size: 16px;
      color: #ffffff;
      border-radius: 4px;
    }
    .disable {
      background-color: #9bd9ba;
    }
  }
}
</style>
<script>
    import api from '../../../../service/modules/refund';
    import util from '../../../../utils/common'
    export default {
        filters: {
            strFilter2 (val) {
                try {
                    return util.getBracketSt(val)[0].replace(/(【|】)/g, '')
                } catch (err) {
                    console.log(err);
                }
            },
            getReason (val) {
                // var index = val.lastIndexOf('：');
                // val = val.substring(index + 1, val.length);
                return val;
            }
        },
        data () {
            return {
                content: '', // 意见
                resultRadio: '1',
                reportingAgency: '', // 上报机构
                reasonReporting: '', // 上报原因
                activeIcon: require('../../../../assets/refund/checkbox-select.png'),
                inactiveIcon: require('../../../../assets/refund/checkbox-defalut.png'),
                detail: {} // 退货单详情
            };
        },
        created () {
            this.detail = this.$route.query.data
            this.reportingAgency = this.$route.query.txt
            this.reasonReporting = this.$route.query.reason
        },
        methods: {
            // 确定
            confirm () {
                try {
                    if (!this.content) {
                        return this.$Toast({
                            message: '请填写审核意见'
                        });
                    }
                    const param = {
                        flowId: this.detail.flowId,
                        content: this.content,
                        status: this.resultRadio === '1' ? 22 : 23
                    }
                    api.audit(param).then(res => {
                        this.$Toast({
                            message: res.msg
                        });
                        setTimeout(() => {
                            // this.$router.replace({
                            //   path: "/refund/refundDetail",
                            //   query: {
                            //     flowId: this.data.flowId
                            //   }
                            // });
                            this.$router.back()
                        }, 1500);
                    });
                } catch (err) {
                    console.log(err);
                }
            }
        }
    };
</script>
